import React, { useContext } from 'react'
import MobileHeader from '@pcln/mobile-header'
import { Box } from 'pcln-design-system'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import {
  ANALYTICS_CATEGORY_FLIGHTS,
  ANALYTICS_CATEGORY_PACKAGES
} from '@/constants/analytics'

const ANALYTICS_CATEGORY: Record<string, string> = {
  flights: ANALYTICS_CATEGORY_FLIGHTS,
  packages: ANALYTICS_CATEGORY_PACKAGES
}

const MobileHeaderWrapper = ({
  selectedProductName,
  children
}: {
  selectedProductName: string
  children: React.ReactNode
}) => {
  const { key = '' } = useContext(BootstrapDataContext)
  const category = ANALYTICS_CATEGORY[key]

  return (
    <Box mt={2} mb={4} boxShadowSize="xl" rounded="round" borderRadius="2xl">
      <Box mt={1} mb="3">
        <MobileHeader
          analyticsCategory={category}
          items={MobileHeader.itemsRefresh}
          mustRefreshIcons
          selectedItem={selectedProductName}
        />
      </Box>
      {children}
    </Box>
  )
}

export default MobileHeaderWrapper
